"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGameAnimationEventStore = useGameAnimationEventStore;
const sessionContext_1 = require("~/game/sessionContext");
function useGameAnimationEventStore() {
    const { battle } = (0, sessionContext_1.useGameSession)();
    return battle.animationEventStore;
}
